import { Share2 } from "lucide-react";

const ShareButton = ({ results, currentPhase }) => {
  if (currentPhase !== 'complete') return null;

  const shareResults = () => {
    const text = `Speed Test Results: ${results.downloadSpeed.toFixed(1)} Mbps down, ${results.uploadSpeed.toFixed(1)} Mbps up, ${results.ping.toFixed(0)}ms ping`;
    if (navigator.share) {
      navigator.share({ text });
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
      alert('Results copied to clipboard!');
    }
  };

  return (
    <div className="flex justify-center">
      <button
        onClick={shareResults}
        className="flex items-center space-x-2 px-6 py-3 bg-[#1E9B4C] hover:bg-green-600 dark:bg-green-600 dark:hover:bg-green-700 text-white rounded-xl transition-colors"
      >
        <Share2 size={16} />
        <span>Share Results</span>
      </button>
    </div>
  );
};
export default ShareButton;